import { IStyle, ITheme } from 'office-ui-fabric-react/lib/Styling';

export interface IEmptyFolderStyleProps {
  theme: ITheme;
}

export interface IEmptyFolderStyles {
  root: IStyle;
  emptyFolderImageContainer: IStyle;
  emptyFolderImage: IStyle;
  emptyFolderTitle: IStyle;
}

export const getStyles = (props: IEmptyFolderStyleProps): IEmptyFolderStyles => {
  const {
    theme
  } = props;

  const {
    fonts,
    palette
  } = theme;

  return {
    root: {
      textAlign: 'center',
      paddingTop: '52px',
      paddingBottom: '174px'
    },
    emptyFolderImageContainer: {
      margin: '0 auto',
      height: '208px',
      width: '208px',
    },
    emptyFolderImage: {
      width: '100%',
      height: '100%'
    },
    emptyFolderTitle: {
      padding: '16px 16px 0px 16px',
      ...fonts.xLarge,
      maxWidth: '400px',
      color: `${palette.neutralSecondary}`,
      margin: '0 auto'
    }
  };
};